export default function Header(){
    return (
        <>
        <h1 id = "mHeader">type to begin</h1> 
        <h2>enter to restart </h2>
        </>
    )
}
